<template>
  <TextBlob headingSize="s">
    <template #heading> Reviews </template>
    <template #text>
      <el-table :data="reviews" :row-class-name="reviewsRow">
        <el-table-column prop="reviewerId.email" label="Email" width="300" />
        <el-table-column prop="rating" label="Rating" width="100" />
        <el-table-column prop="comment" label="Comments" />
        <el-table-column prop="feedback" label="Feedback">
          <template #default="{ row }">
            <span v-if="row.feedback">{{ row.feedback }}</span>
            <span v-else>None</span>
          </template>
        </el-table-column>
      </el-table>
    </template>
  </TextBlob>
</template>

<script setup>
import { ref } from "vue";
import TextBlob from "@/components/TextBlob.vue";
import { ElTable, ElTableColumn } from "element-plus";
import api from "@/composables/api";

const reviews = ref([]);

const reviewsRow = (row) => {
  if (row.row.rating < 3) {
    return 'warning-row'
  } else if (row.row.rating > 4) {
    return 'success-row'
  }
  return ''
}

api(`v1/review/`).then((res) => {
  if (res.data && res.data.reviews.length > 0) {
    reviews.value = res.data.reviews.filter((review) => review.reviewerId.status !== 'archived')
  }
});

</script>
<style scoped>
.el-table .warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-9);
}

.el-table .success-row {
  --el-table-tr-bg-color: var(--el-color-success-light-9);
}
</style>
